 <template>
    <div class="container">
        <div class="product-detail">
            <div class="productDetail-box">
                <div class="product-box">
                    <div class="product-img">
                        <img :src="results.coverUrl" alt="">
                    </div>
                    <div class="product-ind">
                        <p class="product-name">{{results.name}}</p>
                        <p class="product-price">{{results.price}}</p>
                        <!-- <div class="QR-code">
                            <div class="scan">扫一扫购买</div>
                            <img :src="results.payUrl" alt="">
                        </div> -->
                    </div>
                </div>
                <h2>商品详情</h2>
                <div class="product-content" >
                    <div v-html="results.description"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getCompanyProductById } from '../api/api.js'
// import axios from 'axios'
export default {
  data () {
    return {
      results: ''
    }
  },
  methods: {
    getproduct () {
      console.log(this.$route.query.id, this.$route.params.id)
      getCompanyProductById({id: this.$route.params.id}).then(res => {
        console.log(res)
        if (res.status == 200) {
          this.results = res.data.data
          this.results.coverUrl = 'http://121.40.191.9/uploads/image' + this.results.coverUrl
          this.results.payUrl = 'http://121.40.191.9/uploads/image' + this.results.payUrl
        }
      })
    }
  },
  created () {
    this.getproduct()
  },
  updated () {
    let obj = document.getElementsByClassName('product-content')[0]
    let img = obj.getElementsByTagName('img')
    for (let i = 0; i < img.length; i++) {
      img[i].style.width = '100%'
    }
  }
}
</script>

<style lang="scss" >
.container{
    .product-detail{
        width: 70%;
        padding: 0 15%;
        background-color: #f5f5f5;
        .productDetail-box{
            background-color: #fff;
            padding: 48px;
            overflow: hidden;
            .product-box{
                padding: 40px;
                box-sizing: border-box;
                border: 1px solid #e8e8e8;
                display: flex;
                .product-img{
                    margin-right: 80px;
                    width: 282px;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
                .product-ind{
                    display: flex;
                    flex-direction: column;
                    // justify-content: space-around;
                    .product-name{
                        font-size: 20px;
                        color: #2e324f;
                    }
                    .product-price{
                        font-size: 24px;
                        color: #ff6000;
						margin-top: 10px;
                    }
                    .QR-code{
                        width: 150px;
                        padding: 0 10px;
                        box-shadow: 0 1px 3px 1px rgba(0,0,0,.15);
                        .scan{
                            font-size: 16px;
                            color: #2e324f;
                            text-align: center;
                            padding: 10px 0;
                        }
                        img{
                            width: 150px;
                            height: 150px;
                        }
                    }
                }
            }
            h2{
                font-size: 16px;
                color: rgba(0,0,0,.85);
                margin: 30px 0;
                padding: 10px 20px;
                background-color: #f8f8f8;
            }
            .product-content{
                padding: 0 15%;
            }

        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/productDetail.vue